export var ColorType;
(function (ColorType) {
    ColorType["Solid"] = "solid";
    ColorType["LinearGradient"] = "linear-gradient";
})(ColorType || (ColorType = {}));
